module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('router-link', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo.svg"),
      "alt": _vm.pkginfo.description
    }
  }), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": 'v' + _vm.pkginfo.version,
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v("Small Business Analytics ")]), _c('strong', {
    staticClass: "admin"
  }, [_vm._v("SBA")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [(_vm.auth.authenticated) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'My Profile',
        params: {
          username: _vm.auth.username
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v("\n          My Profile\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [(_vm.auth.authenticated) ? _c('router-link', {
    staticClass: "nav-item last-item",
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })]), _vm._v("Log out")]) : _vm._e(), _vm._v(" "), (!_vm.auth.authenticated) ? _c('router-link', {
    staticClass: "nav-item last-item",
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  })]), _vm._v("Log in")]) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb87a0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/Navbar.vue
// module id = 221
// module chunks = 17